import { Pagination, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import PageLoader from "../sub/PageLoader";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function SubUnitsTable(props) {
  const [canStart, setCanStart] = useState(false);
  const [page, setPage] = useState(1);
  const [units, setUnits] = useState([]);

  useEffect(() => {
    setCanStart(true);
    setUnits(props.subunits);
  }, [props.subunits]);

  const columns = [
    {
      title: "Unit name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => <div>{record.name}</div>,
    },
    {
      title: "Level",
      key: "levelId",
      dataIndex: "levelId",
      render: (text, record) => (
        <Tag color={record.organizationLevel?.color}>
          {record.organizationLevel?.name.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Sub units",
      dataIndex: "subUnitsCount",
      key: "subUnitsCount",
      render: (text, record) => <div>{record.subUnitsCount || "0"}</div>,
    },
    {
      title: "Positions",
      dataIndex: "positionsCount",
      key: "positionCounts",
      render: (text, record) => <div>{record.positionsCounts || "0"}</div>,
    },
    {
      title: "Unit head",
      dataIndex: "unitHead",
      key: "unitHead",
      render: (text, record) => <div>{record.unitHead || "-"}</div>,
    },
  ];

  return (
    <>
      {canStart ? (
        <>
          <Table
            columns={columns}
            dataSource={units}
            pagination={false}
            loading={props.loading}
          />
          <div className="text-center mt-6">
            <Pagination
              onChange={(num) => {
                props.changePage(num);
                setPage(num);
              }}
              current={page}
              total={props.data?.totalCount || 0}
              pageSize={LIMIT_PER_PAGE}
            />
          </div>
        </>
      ) : (
        <PageLoader />
      )}
    </>
  );
}

export default SubUnitsTable;
